import { render } from "./Insight.vue?vue&type=template&id=0cf0c316"
import script from "./Insight.vue?vue&type=script&lang=js"
export * from "./Insight.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__